// import React, { useState, useEffect } from 'react';
// import styles from './Dashboard.module.css';
// import { MdScience, MdPeople, MdLocationOn, MdTrendingUp } from 'react-icons/md';
// import { FiFileText, FiCheckCircle, FiEdit3, FiGlobe } from "react-icons/fi";
// import Chart from 'react-apexcharts';

// const Dashboard = () => {
//     const [loading, setLoading] = useState(false);
//     const [stats, setStats] = useState([
//         {
//             title: 'Total Sites',
//             value: '0',
//             change: '',
//             icon: FiGlobe,
//             color: '#f59e0b'
//         },
//         {
//             title: 'Total Submissions',
//             value: '0',
//             change: '',
//             icon: FiFileText,
//             color: '#10b981'
//         },
//         {
//             title: 'Completed',
//             value: '0',
//             change: '',
//             icon: FiCheckCircle,
//             color: '#3b82f6'
//         },
//         {
//             title: 'Drafts',
//             value: '0',
//             change: '',
//             icon: FiEdit3,
//             color: '#f59e0b'
//         }
//     ]);
//     const [submissionData, setSubmissionData] = useState({
//         dates: [],
//         submitted: [],
//         drafts: []
//     });
//     const [recentSubmissions, setRecentSubmissions] = useState([]);
//     const [confirmModal, setConfirmModal] = useState({
//         show: false,
//         title: '',
//         message: '',
//         type: '',
//         onConfirm: () => { }
//     });

//     const getToken = () => {
//         return localStorage.getItem('token');
//     };

//     // Fetch Dashboard Data (Stats and Graph)
//     const fetchDashboardData = async () => {
//         try {
//             setLoading(true);
//             const token = getToken();
//             const response = await fetch(`http://localhost:5000/api/studies/stats`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 }
//             });
//             const data = await response.json();

//             if (data.success) {
//                 console.log('Dashboard Data:', data.data);

//                 // Update stats cards
//                 if (data.data.stats) {
//                     const statsData = data.data.stats;
//                     setStats([
//                         {
//                             title: 'Total Sites',
//                             value: statsData.totalSites?.toString() || '0',
//                             change: '',
//                             icon: FiGlobe,
//                             color: '#f59e0b'
//                         },
//                         {
//                             title: 'Total Submissions',
//                             value: statsData.totalSubmissions?.toString() || '0',
//                             change: '',
//                             icon: FiFileText,
//                             color: '#10b981'
//                         },
//                         {
//                             title: 'Completed',
//                             value: statsData.totalCompleted?.toString() || '0',
//                             change: '',
//                             icon: FiCheckCircle,
//                             color: '#3b82f6'
//                         },
//                         {
//                             title: 'Drafts',
//                             value: statsData.totalDrafts?.toString() || '0',
//                             change: '',
//                             icon: FiEdit3,
//                             color: '#8b5cf6'
//                         }
//                     ]);
//                 }

//                 // Update graph data with separate lines for submitted and drafts
//                 if (data.data.graphData && data.data.graphData.length > 0) {
//                     const dates = data.data.graphData.map(item => item.date);
//                     const submitted = data.data.graphData.map(item => item.submitted || 0);
//                     const drafts = data.data.graphData.map(item => item.drafts || 0);

//                     setSubmissionData({
//                         dates: dates,
//                         submitted: submitted,
//                         drafts: drafts
//                     });
//                 }

//             } else {
//                 setConfirmModal({
//                     show: true,
//                     title: 'Error',
//                     message: data.message || 'Failed to fetch dashboard data',
//                     type: 'error',
//                     onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
//                 });
//             }
//         } catch (error) {
//             console.error('Error fetching dashboard data:', error);
//             setConfirmModal({
//                 show: true,
//                 title: 'Error',
//                 message: 'Failed to fetch dashboard data',
//                 type: 'error',
//                 onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch Recent Submissions
//     const fetchRecentSubmissions = async () => {
//         try {
//             const token = getToken();
//             const response = await fetch(`http://localhost:5000/api/studies/recent-submissions`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 }
//             });
//             const data = await response.json();

//             if (data.success) {
//                 console.log('Recent Submissions:', data.data);
//                 setRecentSubmissions(data.data || []);
//             } else {
//                 console.error('Failed to fetch recent submissions:', data.message);
//             }
//         } catch (error) {
//             console.error('Error fetching recent submissions:', error);
//         }
//     };

//     useEffect(() => {
//         fetchDashboardData();
//         fetchRecentSubmissions();
//     }, []);

//     const formatDateTime = (dateString) => {
//         if (!dateString) return '-';
//         const date = new Date(dateString);
//         return date.toLocaleString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     };
//     const chartOptions = {
//         chart: {
//             type: 'area',
//             height: 350,
//             toolbar: {
//                 show: false
//             },
//             animations: {
//                 enabled: true,
//                 easing: 'easeinout',
//                 speed: 800
//             }
//         },
//         dataLabels: {
//             enabled: false
//         },
//         stroke: {
//             curve: 'smooth',
//             width: 3
//         },
//         colors: ['#10b981', '#f59e0b'],
//         fill: {
//             type: 'gradient',
//             gradient: {
//                 shadeIntensity: 1,
//                 opacityFrom: 0.6,
//                 opacityTo: 0.1,
//                 stops: [0, 90, 100]
//             }
//         },
//         xaxis: {
//             categories: submissionData.dates,
//             title: {
//                 text: 'Date',
//                 style: {
//                     fontSize: '14px',
//                     fontWeight: 600
//                 }
//             },
//             labels: {
//                 formatter: function (value) {
//                     const date = new Date(value);
//                     return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//                 }
//             }
//         },
//         yaxis: {
//             title: {
//                 text: 'Number of Submissions',
//                 style: {
//                     fontSize: '14px',
//                     fontWeight: 600
//                 }
//             },
//             labels: {
//                 formatter: function (value) {
//                     return Math.floor(value);
//                 }
//             }
//         },
//         tooltip: {
//             x: {
//                 format: 'dd MMM yyyy'
//             },
//             y: {
//                 formatter: function (value) {
//                     return value + ' submissions';
//                 }
//             }
//         },
//         legend: {
//             position: 'top',
//             horizontalAlign: 'right',
//             fontSize: '14px',
//             fontWeight: 500,
//             markers: {
//                 width: 10,
//                 height: 10,
//                 radius: 12
//             }
//         },
//         grid: {
//             borderColor: '#f1f1f1',
//             strokeDashArray: 4
//         }
//     };

//     const chartSeries = [
//         {
//             name: 'Submitted',
//             data: submissionData.submitted
//         },
//         {
//             name: 'Drafts',
//             data: submissionData.drafts
//         }
//     ];

//     return (
//         <div className={styles.dashboard}>
//             <div className={styles.header}>
//                 <h1 className={styles.title}>Dashboard</h1>
//                 <p className={styles.subtitle}>Welcome to CRO Portal</p>
//             </div>

//             {loading && (
//                 <div className={styles.loadingOverlay}>
//                     <div className={styles.spinner}></div>
//                 </div>
//             )}

//             <div className={styles.statsGrid}>
//                 {stats.map((stat, index) => (
//                     <div key={index} className={styles.statCard}>
//                         <div className={styles.statIcon} style={{ backgroundColor: `${stat.color}15`, color: stat.color }}>
//                             <stat.icon />
//                         </div>
//                         <div className={styles.statContent}>
//                             <h3 className={styles.statTitle}>{stat.title}</h3>
//                             <p className={styles.statValue}>{stat.value}</p>
//                             {stat.change && <p className={styles.statChange}>{stat.change}</p>}
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             {/* Submissions Graph */}
//             <div className={styles.contentSection}>
//                 <div className={styles.card}>
//                     <h2 className={styles.cardTitle}>Submissions Overview</h2>
//                     <div className={styles.chartContainer}>
//                         {submissionData.dates.length > 0 ? (
//                             <Chart
//                                 options={chartOptions}
//                                 series={chartSeries}
//                                 type="area"
//                                 height={350}
//                             />
//                         ) : (
//                             <div className={styles.noData}>
//                                 <p>No submission data available</p>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Recent Submissions Table */}
//             <div className={styles.contentSection}>
//                 <div className={styles.card}>
//                     <div className={styles.tableHeader}>
//                         <h2 className={styles.cardTitle}>Recent Submissions</h2>
//                         <p className={styles.tableSubtitle}>Latest survey submissions</p>
//                     </div>
//                     <div className={styles.tableContainer}>
//                         {recentSubmissions.length > 0 ? (
//                             <table className={styles.submissionsTable}>
//                                 <thead>
//                                     <tr>
//                                         <th>Full Name</th>
//                                         <th>Email Address</th>
//                                         <th>Contact Number</th>
//                                         <th>Study</th>
//                                         <th>Site</th>
//                                         <th>Submission Date & Time</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {recentSubmissions.map((submission, index) => (
//                                         <tr key={index}>
//                                             <td>{submission.full_name || '-'}</td>
//                                             <td className={styles.emailCell}>{submission.email || '-'}</td>
//                                             <td>{submission.contact_number || '-'}</td>
//                                             <td>{submission.study_title || '-'}</td>
//                                             <td>{submission.site_name || '-'}</td>
//                                             <td className={styles.dateTimeCell}>
//                                                 {formatDateTime(submission.submitted_at)}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         ) : (
//                             <div className={styles.noData}>
//                                 <p>No submissions yet</p>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Confirm Modal */}
//             {confirmModal.show && (
//                 <div className={styles.modalOverlay}>
//                     <div className={styles.modal}>
//                         <h3>{confirmModal.title}</h3>
//                         <p>{confirmModal.message}</p>
//                         <button onClick={confirmModal.onConfirm}>OK</button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;

import React from 'react';
import DashboardHeader from './DashboardHeader';
import StatsGrid from './StatsGrid';
// import SubmissionsChart from './SubmissionsChart';
// import RecentSubmissionsTable from './RecentSubmissionsTable';
import ConfirmModal from './ConfirmModal';
// import { useDashboard } from '../../hooks/useDashboard';
import styles from './Dashboard.module.css';
import SubmissionsChart from './SubmissionChart';
import RecentSubmissionsTable from './RecentSubmissionTable';
import { useDashboard } from './Hooks/UseDashboard';
import LoadingContainer from '../../components/Common/LoadingContainer';

const Dashboard = () => {
    const {
        loading,
        stats,
        submissionData,
        recentSubmissions,
        confirmModal,
        setConfirmModal
    } = useDashboard();

    if (loading) {
        return (
            <div className={styles.dashboard}>
                <DashboardHeader />
                <LoadingContainer message="Loading dashboard..." />
            </div>
        );
    }

    return (
        <div className={styles.dashboard}>
            <DashboardHeader />

            <StatsGrid stats={stats} />

            <SubmissionsChart submissionData={submissionData} />

            <RecentSubmissionsTable submissions={recentSubmissions} />

            <ConfirmModal
                modal={confirmModal}
                onClose={() => setConfirmModal({ ...confirmModal, show: false })}
            />
        </div>
    );
};

export default Dashboard;